<div class="modal-header">
  <h2 class="modal-title">{{ (addDelegateFormVisible ? 'asset.addNewDelegate' : 'asset.selectDelegate') | translate }}</h2>
  <button type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()"
  >
  </button>
</div>

<div class="modal-body d-flex flex-column align-items-center">
    <form [formGroup]="deliveryDelegateFormGroup" class="wizard-item">
        <ng-container *ngIf="!addDelegateFormVisible">
            <div class="row justify-content-center gap-2">
                <div *ngFor="let delegate of delegates; let indexDelegate = index"
                    class="d-flex flex-column col-12 gap-1"
                >
                    <div class="radio-container"
                        [ngClass]="{
                                'item-selected':
                                deliveryDelegateFormGroup.value !== null &&
                                deliveryDelegateFormGroup.value.selectedDelegateId === delegate.delegateId
                            }"
                        (mouseover)="delegate.displayEditIcons = true"
                        (mouseout)="delegate.displayEditIcons = false"
                    >
                        <input
                            class="radio-input delegate-radio-input"
                            type="radio"
                            kendoRadioButton
                            size="large"
                            [value]="delegate.delegateId"
                            formControlName="selectedDelegateId"
                            required
                            id="radio-{{ indexDelegate }}"
                        />
                        <label HJSuppress class="radio-label m-0" for="radio-{{ indexDelegate }}">
                            <span class="fw-bold me-2">
                                {{ delegate.firstName }}
                            </span> {{ delegate.lastName }}
                        </label>
                    </div>

                    <div class="options-div d-flex justify-content-end gap-2"
                        [ngClass]="[
                            delegate.displayEditIcons === false ||
                            delegate.isReadOnly === true
                            ? 'invisible'
                            : '',
                        ]"
                        (mouseover)="delegate.displayEditIcons = true"
                        (mouseout)="delegate.displayEditIcons = false"
                    >
                        <button class="btn edit-btn action-btn" (click)="editDelegateHandler(delegate)">
                            <i class="app-icon icon icon-edit icon-xl"></i>
                        </button>
                        <button *ngIf="delegate.hasRequests || delegate.hasAssetDeliveries" 
                            class="btn delete-btn pe-auto disabled-action-btn"
                            disabled
                            [ngbTooltip]="'requests.wizard.delegateDeleteDisabled' | translate"
                            placement="top"
                        >
                            <i class="app-icon icon icon-delete icon-xl"></i>
                        </button>
                        <button *ngIf="!delegate.hasRequests && !delegate.hasAssetDeliveries" 
                            class="btn delete-btn action-btn"
                            (click)="removeDelegateHandler(delegate)"
                        >
                            <i class="app-icon icon icon-delete icon-xl"></i>
                        </button>
                    </div>  
                </div>

                <div class="col-12 d-flex align-items-start fw-semibold">
                    <button
                        class="btn add-delegate-btn mx-3 flex-grow-1"
                        (click)="addDelegate()"
                    >
                        <i class="app-icon icon icon-add icon-xl me-2"></i>
                        <span>{{ "asset.addNewDelegate" | translate }}</span>
                    </button>
                </div>
            </div>
        </ng-container>

        <app-add-delegate
            #addForm
            *ngIf="addDelegateFormVisible"
            [newDelegate]="newDelegate"
            [isModal]="true"
            (delegateSaved)="delegateSavedHandler($event)"
            (backToList)="backToDelegatesList()"
        ></app-add-delegate>

        
    </form>

    
</div>

<div class="delivery-doc-container d-flex">
    <div class="col-12 delivery-doc-info d-flex align-items-center gap-4">
        <i class="app-icon icon icon-warning-circle icon-xl text-secondary"></i>
        <div class="fs-14px" [innerHTML]="'asset.delegateModalDeliveryInfo' | translate"></div>
    </div>
</div>

<div class="modal-footer">
  <button class="btn link-btn" (click)="closeModal()">
    {{ "common.closeButton" | translate }}
  </button>
  <button *ngIf="!addDelegateFormVisible" class="btn btn-primary text-light" (click)="selectDelegateHandler()">
    {{ "common.select" | translate }}
  </button>
   <button *ngIf="addDelegateFormVisible" class="btn btn-primary text-light" (click)="saveDelegate()">
    {{ (newDelegate.delegateId ? 'common.save' : 'common.add') | translate }}
  </button>
</div>